var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['shaded-container', _vm.shadowClass]},[_c('div',{staticClass:"overlay top"}),_vm._v(" "),_c('div',{ref:"watchContainer",staticClass:"container"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"overlay bottom"})])
}
var staticRenderFns = []

export { render, staticRenderFns }